import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { parameter } from 'src/app/interfaces/action';
import { DialogService } from 'src/app/services/dialog.service';
import { FormulaTSService } from 'src/app/services/formula-ts.service';
import { HTTPService } from 'src/app/services/http.service';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { CustomActionParametersComponent } from '../../simple-datagrid/custom-action-parameters/custom-action-parameters.component';
import { Variable } from '../formula-tester.component';

export interface FormulaList{
    name:string;
    description:string;
    sintaxe?:sintaxe;
    
}
export interface sintaxe{
    expression:string;
    parameters:string[];
    types:string[]
}

@Component({
    selector: 'formula-tester-action',
    templateUrl: './formula-tester-action.component.html',
    styleUrls: ['./formula-tester-action.component.scss'],
    standalone: false
})
export class FormulaTesterActionComponent implements OnInit {

  constructor(private http:HTTPService, public breakpointObserver: BreakpointObserver,
    public tsFormula:FormulaTSService) { 
    this.formulaListTemp = this.formulaList;
  }


  resultado:string;
  sub5:Subscription;
  sub6:Subscription;
  sub11:Subscription;
  showDesc = false;
  vertical=true;
  @Input() small;
  @Input() ts = false;
  @Input() formula:string ="function(1)";
  @Output() formulaChange:EventEmitter<string> = new EventEmitter<string>();
  @Input() listvariable:Variable[] = [];
  selectedItem:FormulaList = null;

  formulaList:FormulaList[]= [];
  /*[{
      name:"replace",
      description: "Formula de Substituição de Caracters",
      sintaxe: []
  },
  {
    name:"findjson",
    description: "Formula de Busca de Dados no JSON dasdas das d\n dasdsadasasn\n",
    sintaxe: [{
        expression:"findJSON",
        parameters:['Valor','De','Para'],
        types:['S','S','S']
    },
    {
      expression:"findJSON",
      parameters:['Valor','De','Para','Val2'],
      types:['S','S','S']
    }]
  }

];*/

  formulaListTemp:FormulaList[]= [];

  ngOnInit(): void {

    if ( this.ts){
      this.formulaList = this.tsFormula.formulas;
      this.formulaListTemp = this.tsFormula.formulas;
      
    }else{
      this.loadFormula().then(d=>{
        if (this.small) {
          this.vertical = false;
        }else{
          this.vertical = true;
        }  
      });
    }
    
    
    
  }

  updateFilter(event){
    let filterValue = null;
  
    if ( event == null || event ==''){
      this.formulaListTemp = this.formulaList;  
      return;
    }
    
    if (event) {
      filterValue = (event.target as HTMLInputElement).value;
    }

    this.formulaListTemp = this.formulaList.filter((data) => {
      let name:boolean = data.name.toString().toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;      
      let description:boolean = data.description.toString().toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;      
      let sintaxe:boolean = data.sintaxe.toString().toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;      
      return  name || description || sintaxe;
    });
    
  }

  executeFormula(){

    if ( this.formula == null || this.formula==""){
      return;
    }

    if ( this.ts ){
        let param = new Map<string,any>();
        this.tsFormula.toMap(this.listvariable, param);
        this.resultado = this.tsFormula.calculate(this.formula,param);
        return;
    }

    let ob = {
      expressao: this.formula,
      novo: true,
      values: this.listvariable
    }

    this.listvariable.forEach(d=>{
      if ( d.key == "@CODECOMPANY" ){
        ob['codecompany']=d.value;
      } 
      if ( d.key == "@CODEMKTP" ){
        ob['codemktp']=d.value;
      } 
      if ( d.key == "@CODECONTRACT" ){
        ob['codecontract']=d.value;
      } 
    });
  
    this.sub5 = this.http.post(ob,"FormulaServices/test",true,true,false).subscribe(x=>{
        this.resultado = x['resultado'];
    })
  }

  ngOnDestroy(){
    if ( this.sub5!=null){this.sub5.unsubscribe()}
    if ( this.sub6!=null){this.sub6.unsubscribe()}
    if ( this.sub11!=null){this.sub11.unsubscribe()}
  }

  emitEvent(event){
    this.formulaChange.emit(this.formula);
  }
  

  public dragstart_handler(event: any) {
    let value ="";
    
    let item:FormulaList =  JSON.parse(event.target.dataset.dragData) as FormulaList;
    if (item.sintaxe == null ){
        value = item.name+"()";
    }else{
        //value  = JSON.stringify(item); TODO
        value  = item.sintaxe.expression+"("+item.sintaxe.parameters+")";
    }
    event.dataTransfer.setData('text/plain', value);
    
  }

  public dragstart_handler2(event: any) {
    let value ="";
  
    let item:sintaxe =  JSON.parse(event.target.dataset.dragData) as sintaxe;
  
    value  = item.expression+"("+item.parameters+")";
    event.dataTransfer.setData('text/plain', value);
    
  }

  public loadFormula(){
    return new Promise((resolve,reject)=>{
      
      this.sub6 = this.http.post({},"FormulaServices/expressions",true,true,false).subscribe(x=>{
        this.formulaList = x['resultado'] as FormulaList[];
        this.formulaListTemp = x['resultado'] as FormulaList[];
        

        
        this.formulaListTemp.sort((a,b)=>{
            if ( a.name.toUpperCase().trim() > b.name.toUpperCase().trim()){
                return 1;
            }

            if ( a.name.toUpperCase().trim() < b.name.toUpperCase().trim()){
              return -1;
          }
          return 0;
        });

        this.formulaList.sort((a,b)=>{
          if ( a.name.toUpperCase().trim() > b.name.toUpperCase().trim()){
              return 1;
          }

          if ( a.name.toUpperCase().trim() < b.name.toUpperCase().trim()){
            return -1;
        }
        return 0;
      })
        //this.formulaListTemp.push(...x['resultado'] as FormulaList[]);
        

        resolve(true);
      })
    });
  }

  public drop_handler(event: any) {
    var data = event.dataTransfer.getData("text/plain");
    //TODO//
    /*try{
       let item:FormulaList = JSON.parse(data) as FormulaList;
       
       if ( item.sintaxe.length > 0 ){
        //event.dataTransfer.setData('text/plain', "");
        let param= [{"parameterName":"para1","parameterDesc":"par1","parameterType":"S"},
        {"parameterName":"para2","parameterDesc":"par2","parameterType":"S"}];

        this.dialog.openGenericDialog(CustomActionParametersComponent,param,(data)=>{
          if ( ObjectUtil.isNotEmpty(this.formula)){
            this.formula = this.formula + data;
          }else{
            this.formula =  data;
          }
          
        })
      }
    }catch(Exception){

    }
    */
  }

}
